import React, { useState } from "react";
import { MdDeleteOutline, MdDownload } from "react-icons/md";
import TempThree from "../../components/helpers/walletTabs/tempThree";
const Customers3 = () => {
  const [actionModal] = useState(false);

  return (
    <>
      <div className="relative  px-3">
       <TempThree />
        {actionModal && (
          <>
            <div className="flex flex-col gap-8 w-[10rem] p-4 absolute top-44 right-[30rem] z-50 rounded-md border border-[#88087B] bg-[#fff]">
              <p className="flex gap-2 items-center font-bold cursor-pointer">
                <MdDownload size={25} className="" />
                Export
              </p>
              <p className="flex gap-2 items-center text-[#D11C1C] font-bold cursor-pointer">
                <MdDeleteOutline size={25} className=" text-[#D11C1C]" />
                Delete
              </p>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Customers3;
